import { Component } from '@theme/component';

class AacArtQuiz extends Component {
  requiredRefs = [
    'entry',
    'form',
    'progress',
    'back',
    'next',
    'finish',
    'status',
    'results',
    'cards',
    'resultsHeading',
  ];

  connectedCallback() {
    super.connectedCallback();

    if (this.initialized) return;

    this.initialized = true;
    this.step = 0;
    this.showStep(false);
  }

  get questions() {
    return Array.from(this.querySelectorAll('.aac-quiz__question'));
  }

  get experiences() {
    return Array.from(this.querySelectorAll('template[data-quiz-result]')).map((template, index) => ({
      index,
      title: template.dataset.title || '',
      description: template.dataset.description || '',
      url: template.dataset.url || '',
      template,
    }));
  }

  showStep(focus = true) {
    const questions = this.questions;
    const lastStep = Math.max(questions.length - 1, 0);

    this.step = Math.min(Math.max(this.step, 0), lastStep);

    for (const [index, question] of questions.entries()) {
      question.hidden = index !== this.step;
    }

    this.refs.back.hidden = this.step === 0;
    this.refs.next.hidden = this.step === lastStep;
    this.refs.finish.hidden = this.step !== lastStep;
    this.refs.progress.textContent = `${this.dataset.progressPrefix} ${this.step + 1}${this.dataset.progressSuffix}`;

    if (focus) this.refs.progress.focus();
  }

  handleStart() {
    this.refs.entry.hidden = true;
    this.refs.form.hidden = false;
    this.refs.results.hidden = true;
    this.refs.status.textContent = '';
    this.showStep();
  }

  handleNext() {
    const question = this.questions[this.step];
    if (!question) return;

    const firstInput = question.querySelector('input');
    const checkedInput = question.querySelector('input:checked');

    if (!checkedInput) {
      firstInput?.reportValidity();
      return;
    }

    this.step += 1;
    this.showStep();
  }

  handleBack() {
    this.step -= 1;
    this.showStep();
  }

  handleClose() {
    this.refs.form.hidden = true;
    this.refs.results.hidden = true;
    this.refs.entry.hidden = false;
    this.refs.status.textContent = '';
  }

  /** @param {SubmitEvent} event */
  handleSubmit(event) {
    event.preventDefault();

    if (!this.refs.form.reportValidity()) return;

    const experiences = this.experiences;
    const scores = experiences.map(() => 0);

    for (const input of this.refs.form.querySelectorAll('input:checked')) {
      const weights = (input.dataset.scores || '').split(',').map(Number);

      for (const [index, weight] of weights.entries()) {
        scores[index] += Number.isFinite(weight) ? weight : 0;
      }
    }

    const together = new FormData(this.refs.form).get('q3') === '2';
    const ranked = experiences
      .map((item, index) => ({ ...item, score: scores[index] }))
      .filter((item) => together || item.index !== 5)
      .sort((a, b) => b.score - a.score || a.index - b.index)
      .slice(0, 3);

    this.refs.cards.replaceChildren();

    for (const [index, item] of ranked.entries()) {
      const card = document.createElement('li');
      const rank = document.createElement('p');
      const title = document.createElement('h4');
      const description = document.createElement('p');
      const link = document.createElement('a');

      card.className = 'aac-quiz__card';
      rank.className = 'aac-quiz__rank';
      rank.textContent = `RECOMMEND 0${index + 1}`;
      title.textContent = item.title;
      description.textContent = item.description;
      link.href = item.url;
      link.textContent = this.dataset.detailLabel;

      card.append(rank, item.template.content.cloneNode(true), title, description, link);
      this.refs.cards.append(card);
    }

    this.refs.form.hidden = true;
    this.refs.results.hidden = false;
    this.refs.status.textContent = this.dataset.foundStatus;
    this.refs.resultsHeading.focus();
  }

  handleReset() {
    this.refs.form.reset();
    this.refs.cards.replaceChildren();
    this.step = 0;
    this.handleStart();
    this.refs.status.textContent = this.dataset.resetStatus;
  }
}

if (!customElements.get('aac-art-quiz')) {
  customElements.define('aac-art-quiz', AacArtQuiz);
}
